import { Injectable } from '@angular/core';
import { GlobalConstants } from '../constant/constant';
import { AppUserAssignmentService } from './app-user-assignment.service';
import { LookupService } from './lookup.service';
import { TimeRecordService } from './timeRecord.service';

@Injectable({
  providedIn: 'root',
})
export class TimeEntryIntervalResolverService {
  constructor(
    private appUserAssignmentService: AppUserAssignmentService,
    private lookupService: LookupService,
    private timeRecordService: TimeRecordService
  ) {}

  async resolveIntervalForDate(userId: number, dateTime: string, timeZoneId: string, isExempt: boolean | null | undefined): Promise<number> {
    if (isExempt) {
      console.debug('[TimeEntryIntervalResolver] resolveIntervalForDate -> default interval (exempt)', {
        userId,
        dateTime,
        timeZoneId,
        isExempt,
        interval: GlobalConstants.DEFAULT_TIMECLOCK_INTERVAL_MINUTES,
      });
      return GlobalConstants.DEFAULT_TIMECLOCK_INTERVAL_MINUTES;
    }

    const enclosingTimeRecord = await this.timeRecordService.getWorkingTimeRecordEnclosingDatetime(userId, dateTime, timeZoneId);
    const fipsStateId = enclosingTimeRecord?.FIPSStateId ?? this.appUserAssignmentService.currentAssignment?.FIPSStateId;

    console.debug('[TimeEntryIntervalResolver] resolveIntervalForDate -> resolved FIPS source', {
      userId,
      dateTime,
      timeZoneId,
      isExempt,
      enclosingTimeRecordFipsStateId: enclosingTimeRecord?.FIPSStateId,
      currentAssignmentFipsStateId: this.appUserAssignmentService.currentAssignment?.FIPSStateId,
      selectedFipsStateId: fipsStateId,
    });

    return this.resolveIntervalForFipsStateId(fipsStateId, isExempt);
  }

  async resolveIntervalForFipsStateId(fipsStateId: number | null | undefined, isExempt: boolean | null | undefined): Promise<number> {
    if (isExempt || !fipsStateId) {
      console.debug('[TimeEntryIntervalResolver] resolveIntervalForFipsStateId -> default interval (exempt or missing FIPS)', {
        fipsStateId,
        isExempt,
        interval: GlobalConstants.DEFAULT_TIMECLOCK_INTERVAL_MINUTES,
      });
      return GlobalConstants.DEFAULT_TIMECLOCK_INTERVAL_MINUTES;
    }

    const fipsState = await this.lookupService.getFipsStateById(fipsStateId);
    const interval = this.getIntervalForFipsState(isExempt, fipsState);

    console.debug('[TimeEntryIntervalResolver] resolveIntervalForFipsStateId -> computed interval', {
      fipsStateId,
      isExempt,
      timeRoundToMinutes: fipsState?.TimeRoundToMinutes,
      interval,
    });

    return interval;
  }

  getIntervalForFipsState(isExempt: boolean | null | undefined, fipsState: { TimeRoundToMinutes?: boolean } | null | undefined): number {
    return this.isPerMinuteNonExemptEntry(isExempt, fipsState)
      ? 1
      : GlobalConstants.DEFAULT_TIMECLOCK_INTERVAL_MINUTES;
  }

  isPerMinuteNonExemptEntry(isExempt: boolean | null | undefined, fipsState: { TimeRoundToMinutes?: boolean } | null | undefined): boolean {
    return isExempt === false && fipsState?.TimeRoundToMinutes === true;
  }
}
